import { render, staticRenderFns } from "./triggers-statistics.vue?vue&type=template&id=182f5d2a&scoped=true&"
import script from "./triggers-statistics.vue?vue&type=script&lang=ts&"
export * from "./triggers-statistics.vue?vue&type=script&lang=ts&"
import style0 from "./triggers-statistics.vue?vue&type=style&index=0&id=182f5d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f5d2a",
  null
  
)

export default component.exports